<div class="container">
  <div class="header">
    <pdq-heading element="h3">Attention: Global A/B variant sample size</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      <span>Are you sure? Saving a new global A/B variant sample size will end all open A/B tests.</span>
    </div>
  </div>
  <footer style="justify-content: flex-end">
    <pdq-button label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
    <pdq-button variant="primary" label="Save" (click)="save()"></pdq-button>
  </footer>
</div>
